import { render, staticRenderFns } from "./ComplaintDelete.vue?vue&type=template&id=41fe04ac&"
import script from "./ComplaintDelete.vue?vue&type=script&lang=js&"
export * from "./ComplaintDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports